import React, { Fragment, useEffect, useState } from "react";
import { getBooking, getPreviousBooking } from "api/booking/booking"; // Adjust the import path as needed
import toast from "react-hot-toast";
import carimg from "images/logo.png"; // Adjust the import path as needed
import moment from "moment";
import {
  Transition,
  Dialog,
  TransitionChild,
  DialogPanel,
  DialogTitle,
  Button,
} from "@headlessui/react";
import { XMarkIcon } from "@heroicons/react/24/solid";
import { globalJson } from "global/global_json";
import ButtonPrimary from "shared/Button/ButtonPrimary";
import PrivacyPolicy from "containers/PageHome/PrivacyPolicy";
import { getPrivacyPolicyContent } from "api/rental-agreement/rental-agreement";
import { getAgreementPdfBase } from "utils/agreement-url";
import Cancellation from "containers/PageHome/Cancellation";
import Pagination from "utils/pagination";
import PhoneNumberDisplay from "utils/PhoneFormat";
import {
  formatDateToHumanFirendly,
  formatTimeToHumanFirendly12Hour,
  formatTimeToHumanFirendly24Hour,
} from "utils/date-format";
import { useData } from "data/data-provider";

const iconLocation = (
  <svg
    width="22"
    height="22"
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.9999 12.3108C12.5794 12.3108 13.8599 11.0304 13.8599 9.45082C13.8599 7.87129 12.5794 6.59082 10.9999 6.59082C9.42036 6.59082 8.13989 7.87129 8.13989 9.45082C8.13989 11.0304 9.42036 12.3108 10.9999 12.3108Z"
      stroke="#292D32"
      strokeWidth="1.5"
    />
    <path
      d="M3.31823 7.78254C5.12406 -0.155791 16.8849 -0.146624 18.6816 7.79171C19.7357 12.4484 16.8391 16.39 14.2999 18.8284C12.4574 20.6067 9.5424 20.6067 7.69073 18.8284C5.16073 16.39 2.26406 12.4392 3.31823 7.78254Z"
      stroke="#292D32"
      strokeWidth="1.5"
    />
  </svg>
);
const iconCalendar = (
  <svg
    width="22"
    height="22"
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.33325 1.83337V4.58337"
      stroke="#292D32"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.6667 1.83337V4.58337"
      stroke="#292D32"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3.20825 8.33264H18.7916"
      stroke="#292D32"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M19.25 7.79171V15.5834C19.25 18.3334 17.875 20.1667 14.6667 20.1667H7.33333C4.125 20.1667 2.75 18.3334 2.75 15.5834V7.79171C2.75 5.04171 4.125 3.20837 7.33333 3.20837H14.6667C17.875 3.20837 19.25 5.04171 19.25 7.79171Z"
      stroke="#292D32"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.3869 12.5582H14.3951"
      stroke="#292D32"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.3869 15.3082H14.3951"
      stroke="#292D32"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.9958 12.5582H11.004"
      stroke="#292D32"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.9958 15.3082H11.004"
      stroke="#292D32"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.6032 12.5582H7.61143"
      stroke="#292D32"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.6032 15.3082H7.61143"
      stroke="#292D32"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
const iconClock = (
  <svg
    width="22"
    height="22"
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M20.1666 11C20.1666 16.06 16.0599 20.1667 10.9999 20.1667C5.93992 20.1667 1.83325 16.06 1.83325 11C1.83325 5.94004 5.93992 1.83337 10.9999 1.83337C16.0599 1.83337 20.1666 5.94004 20.1666 11Z"
      stroke="#292D32"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.4009 13.915L11.5592 12.2192C11.0642 11.9258 10.6609 11.22 10.6609 10.6425V6.88416"
      stroke="#292D32"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
const iconCar = (
  <svg
    width="22"
    height="22"
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M20.1666 14.137V16.9583C20.1666 17.3854 20.1666 17.599 20.0968 17.7674C20.0038 17.992 19.8253 18.1705 19.6007 18.2635C19.4322 18.3333 19.2187 18.3333 18.7916 18.3333C18.3645 18.3333 18.1509 18.3333 17.9824 18.2635C17.7579 18.1705 17.5794 17.992 17.4863 17.7674C17.4166 17.599 17.4166 17.3854 17.4166 16.9583C17.4166 16.5312 17.4166 16.3176 17.3468 16.1492C17.2538 15.9246 17.0753 15.7461 16.8507 15.6531C16.6822 15.5833 16.4687 15.5833 16.0416 15.5833H5.95825C5.53114 15.5833 5.31758 15.5833 5.14913 15.6531C4.92452 15.7461 4.74606 15.9246 4.65303 16.1492C4.58325 16.3176 4.58325 16.5312 4.58325 16.9583C4.58325 17.3854 4.58325 17.599 4.51348 17.7674C4.42044 17.992 4.24199 18.1705 4.01738 18.2635C3.84892 18.3333 3.63536 18.3333 3.20825 18.3333C2.78114 18.3333 2.56758 18.3333 2.39913 18.2635C2.17452 18.1705 1.99606 17.992 1.90303 17.7674C1.83325 17.599 1.83325 17.3854 1.83325 16.9583V14.137C1.83325 13.035 1.83325 12.4839 1.99058 11.9643C2.14791 11.4446 2.45357 10.9861 3.06489 10.0692L3.66659 9.16663L4.548 7.05124C5.23157 5.41065 5.57337 4.59035 6.26616 4.12849C6.95895 3.66663 7.84761 3.66663 9.62492 3.66663H12.3749C14.1522 3.66663 15.0409 3.66663 15.7337 4.12849C16.4265 4.59035 16.7682 5.41065 17.4519 7.05124L18.3333 9.16663L18.935 10.0692C19.5463 10.9861 19.8519 11.4446 20.0093 11.9643C20.1666 12.4839 20.1666 13.035 20.1666 14.137Z"
      stroke="#141B34"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M1.83325 7.79163L3.66659 9.16663L5.28096 9.57023C5.42638 9.60653 5.57572 9.62496 5.72561 9.62496H16.2742C16.4241 9.62496 16.5734 9.60653 16.7189 9.57023L18.3333 9.16663L20.1666 7.79163"
      stroke="#141B34"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M16.5 12.8334V12.8434"
      stroke="#141B34"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M5.5 12.8334V12.8434"
      stroke="#141B34"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export default function PreviousBookings({
  booking_id,
}: {
  booking_id: string;
}) {
  const [bookings, setBookings] = useState<any>({});
  const [loading, setLoading] = useState<boolean>(true);
  const [isTotalBillModalOpen, setIsTotalBillModalOpen] = useState(false);
  const [selectedInvoice, setSelectedInvoice] = useState<any>(null);
  let [isTermOpen, setIsTermOpen] = useState(false);
  let [isCancellationOpen, setIsCancellationOpen] = useState(false);
  const [privacyPolicy, setPrivacyPolicy] = useState();
  const [cancellationPolicy, setCancellationPolicy] = useState();
  const [isOpen, setIsOpen] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const pageSize = 10;
  const totalPages = Math.ceil((bookings.count || 1) / pageSize);
  const { ourCompany } = useData();

  useEffect(() => {
    const fetchUserBookings = async () => {
      setLoading(true);
      try {
        const offset = (currentPage - 1) * pageSize;
        const result = await getPreviousBooking(booking_id, offset);
        setBookings(result.data || {});
      } catch (err) {
        toast.error("Failed to fetch bookings");
      } finally {
        setLoading(false);
      }
    };

    if (booking_id) {
      fetchUserBookings();
    }
  }, [booking_id, currentPage]);

  useEffect(() => {
    const getContent = async () => {
      setLoading(true);
      try {
        const response = await getPrivacyPolicyContent(
          process.env.REACT_APP_ENV !== "prod"
            ? globalJson.dev_company_id
            : globalJson.prod_company_id
        );

        setCancellationPolicy(response.data.cancellation_policy);
        setPrivacyPolicy(response.data.privacy_policy);
        setLoading(false);
      } catch (error) {
        setLoading(false);
        console.error("Error fetching content", error);
      }
    };

    getContent();
  }, []);

  const handleOpenTotalBillModal = () => {
    setIsTotalBillModalOpen(true);
  };

  const handleCloseTotalBillModal = () => {
    setIsTotalBillModalOpen(false);
  };

  function close() {
    setIsOpen(false);
  }

  /* The agreement key is the booking's uuid. It used to be
     `{pk}b6cr4{companyId}b6cr4{base64(email)}`, but the backend only ever read
     the first segment — the company id was logged and never checked, and the
     email was ignored outright — so a guessed integer opened any operator's
     agreement (1NOW-10707). Both dead segments are gone with it. */
  const openRentalAgreement = async (booking: any) => {
    const path = booking?.unique_identifier;
    const url = getAgreementPdfBase();
    window.open(`${url}${path}`, "_blank");
  };

  if (loading) {
    return (
      <div className="max-w-6xl mx-auto p-6">
        <h2 className="text-2xl md:text-3xl font-bold mb-6 text-text-color">Previous Bookings</h2>
        <div className="text-center py-8">
          <div className="spinner-border animate-spin inline-block w-8 h-8 border-4 rounded-full border-t-transparent border-gray-300"></div>
        </div>
      </div>
    );
  }

  return (
    <>
      <div className="max-w-6xl mx-auto p-6">
        <h2 className="text-2xl md:text-3xl font-bold mb-6 text-text-color">Previous Bookings</h2>

        {!loading && (!bookings.results || bookings.results.length === 0) ? (
          <div className="text-gray-500">No previous bookings found.</div>
        ) : (
          <div className="space-y-6">
            {bookings.results.map((booking: any, idx: number) => (
              <>
                <div key={idx} className="rounded-xl shadow-none py-6">
                  <div className="flex flex-col md:flex-row gap-4 md:gap-6 items-start md:items-center">
                    <img
                      src={
                        booking?.fleet?.first_image
                          ? booking.fleet.first_image
                          : "https://tenant.fleetwire.io/images/vehicle-placeholder.jpg"
                      }
                      alt="Car"
                      onClick={() =>
                        window.open(
                          `/booking-details?id=${booking?.unique_identifier}`,
                          "_blank"
                        )
                      }
                      className="w-[80px] h-[80px] sm:w-[100px] sm:h-[100px] object-cover rounded-xl  mx-auto md:mx-0"
                    />
                    <div className="flex-1 grid grid-cols-1 md:grid-cols-3 gap-4 ">
                      <div className="space-y-4 md:border-r md:border-[#12121240] md:pr-6">
                        <h3 className="font-bold text-base sm:text-lg mb-2">
                          Booking Details
                        </h3>
                        <div className="flex space-x-1 mb-1">
                          <span className="flex-shrink-0 self-start">
                            {iconLocation}
                          </span>
                          <span className="truncate">
                            Pickup: {booking.pick_up_address}
                          </span>
                        </div>
                        <div className="flex space-x-1 mb-1">
                          <span className="flex-shrink-0 self-start">
                            {iconCar}
                          </span>
                          <span className="truncate">
                            {booking.fleet?.name}
                          </span>
                        </div>
                        <div className="flex space-x-1 mb-1">
                          <span className="flex-shrink-0 self-start">
                            {iconCalendar}
                          </span>
                          <span>
                            {formatDateToHumanFirendly(booking.pick_up_time)} -{" "}
                            {formatDateToHumanFirendly(booking.drop_off_time)}
                          </span>
                        </div>
                        <div className="flex space-x-1 mb-1">
                          <span className="flex-shrink-0 self-start">
                            {iconClock}
                          </span>
                          <span>
                            <span>
                              {ourCompany?.default_time_format === "24_hour"
                                ? formatTimeToHumanFirendly24Hour(
                                    booking?.pick_up_time
                                  )
                                : formatTimeToHumanFirendly12Hour(
                                    booking?.pick_up_time
                                  )}
                              -{" "}
                              {ourCompany?.default_time_format === "24_hour"
                                ? formatTimeToHumanFirendly24Hour(
                                    booking?.drop_off_time
                                  )
                                : formatTimeToHumanFirendly12Hour(
                                    booking?.drop_off_time
                                  )}
                            </span>
                          </span>
                        </div>
                      </div>
                      <div className="space-y-2 mt-4 md:mt-0 md:border-r md:border-[#12121240] md:pr-6 md:pl-6">
                        <h3 className="font-bold text-base sm:text-lg mb-2">
                          Renter Information
                        </h3>
                        <div className="truncate">
                          {booking.customer?.first_name +
                            " " +
                            booking.customer?.last_name}
                        </div>
                        <div className="truncate">
                          {booking.customer?.email}
                        </div>
                        <div className="truncate">
                          <PhoneNumberDisplay
                            textColor="#5E5E5E"
                            phone={booking.customer?.phone_no}
                          />
                        </div>
                      </div>
                      <div className="space-y-2 mt-4 md:mt-0 md:pl-6 cursor-pointer">
                        <h3 className="font-bold text-base sm:text-lg mb-2">
                          Trip Info
                        </h3>
                        <div
                          className="mb-1 flex items-center justify-between cursor-pointer"
                          onClick={() => {
                            setSelectedInvoice(booking.invoice);
                            setIsTotalBillModalOpen(true);
                          }}
                        >
                          <span>Total Bill:</span>
                          <span className="font-medium">
                            {booking.sub_total}
                          </span>
                        </div>

                        <div className="mb-1 flex items-center justify-between">
                          <span>Agreement</span>
                          <div
                            onClick={() => openRentalAgreement(booking)}
                            className="text-green-600 font-medium hover:underline cursor-pointer"
                          >
                            View Agreement &gt;
                          </div>
                        </div>
                        <div className="mb-1 flex items-center justify-between">
                          <span>Privacy Policy</span>
                          <div
                            onClick={() => {
                              setIsTermOpen(true);
                            }}
                            className="text-green-600 font-medium hover:underline cursor-pointer"
                          >
                            View Policy &gt;
                          </div>
                        </div>
                        <div className="mb-1 flex items-center justify-between">
                          <span>Cancellation Policy</span>
                          <div
                            onClick={() => {
                              setIsCancellationOpen(true);
                            }}
                            className="text-green-600 font-medium hover:underline cursor-pointer"
                          >
                            View Policy &gt;
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <hr className="my-6 border-[#12121240]" />
              </>
            ))}
          </div>
        )}
        {bookings.results && bookings.results.length > 0 && (
          <div className="mt-6">
            <Pagination
              currentPage={currentPage}
              totalPages={totalPages}
              onPageChange={(page: any) => setCurrentPage(page)}
            />
          </div>
        )}
      </div>
      <Transition appear show={isTotalBillModalOpen}>
        <Dialog
          as="div"
          className="relative z-50"
          onClose={handleCloseTotalBillModal}
        >
          <div className="fixed inset-0 z-50 w-screen overflow-y-auto">
            <div className="flex min-h-full items-center justify-center p-4">
              <TransitionChild
                enter="ease-out duration-300"
                enterFrom="opacity-0 transform scale-95"
                enterTo="opacity-100 transform scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 transform scale-100"
                leaveTo="opacity-0 transform scale-95"
              >
                <DialogPanel className="w-full max-w-md bg-white p-6 rounded-xl shadow-lg !z-50">
                  <div className="flex justify-between mb-4 border-b pb-2">
                    <DialogTitle as="h2" className="text-xl font-bold">
                      Invoice
                    </DialogTitle>
                    <button onClick={handleCloseTotalBillModal}>
                      <XMarkIcon className="h-6 w-6" />
                    </button>
                  </div>
                  <span
                    className="text-sm font-medium leading-5 text-left text-[#79808B] cursor-pointer"
                    onClick={handleOpenTotalBillModal}
                  >
                    <div className="flex flex-col space-y-4">
                      <div className="w-full mx-auto">
                        {selectedInvoice?.breakdown?.fleet &&
                          Object.keys(selectedInvoice.breakdown.fleet).length >
                            0 && (
                            <div className="mt-4">
                              <span className="text-lg font-semibold text-gray-700 dark:text-gray-300">
                                Trip Price
                              </span>
                              <div className="flex justify-between ">
                                <span>
                                  {selectedInvoice?.breakdown?.fleet?.name}
                                </span>
                                <div className="flex flex-col items-end">
                                  <span className="text-xl font-medium text-gray-900 dark:text-gray-100">
                                    ${selectedInvoice?.breakdown?.fleet?.total}
                                  </span>
                                  <span className="text-sm text-gray-500 dark:text-gray-400">
                                    ${selectedInvoice?.breakdown?.fleet?.rate}
                                  </span>
                                </div>
                              </div>
                            </div>
                          )}
                        {selectedInvoice?.breakdown?.locations.length > 0 && (
                          <div className="mt-4">
                            <span className="text-lg font-semibold text-gray-700 dark:text-gray-300">
                              Location Total
                            </span>
                            {selectedInvoice?.breakdown?.locations?.map(
                              (location: any) => (
                                <>
                                  <div className="flex justify-between ">
                                    <span>{location.name}</span>
                                    <div className="flex flex-col items-end">
                                      <span className="text-xl font-medium text-gray-900 dark:text-gray-100">
                                        ${location?.total}
                                      </span>
                                    </div>
                                  </div>
                                </>
                              )
                            )}
                          </div>
                        )}

                        {selectedInvoice?.breakdown?.insurance.length > 0 && (
                          <div className="mt-4">
                            <span className="text-lg font-semibold text-gray-700 dark:text-gray-300">
                              Insurance Total
                            </span>

                            {selectedInvoice?.breakdown?.insurance?.map(
                              (insurance: any) => (
                                <>
                                  <div className="flex justify-between ">
                                    <span>{insurance?.name}</span>
                                    <div className="flex flex-col items-end">
                                      <span className="text-xl font-medium text-gray-900 dark:text-gray-100">
                                        ${insurance?.total}
                                      </span>
                                      <span className="text-sm text-gray-500 dark:text-gray-400">
                                        {insurance?.rate}
                                      </span>
                                    </div>
                                  </div>
                                </>
                              )
                            )}
                          </div>
                        )}

                        {selectedInvoice?.breakdown?.extras.length > 0 && (
                          <div className="mt-4">
                            <span className="text-lg font-semibold text-gray-700 dark:text-gray-300">
                              Trip Extras
                            </span>

                            {selectedInvoice?.breakdown?.extras?.map(
                              (extra: any) => (
                                <>
                                  <div className="flex justify-between ">
                                    <span>{extra.name}</span>
                                    <div className="flex flex-col items-end">
                                      <span className="text-xl font-medium text-gray-900 dark:text-gray-100">
                                        ${extra.total}
                                      </span>
                                      <span>${extra.rate}</span>
                                    </div>
                                  </div>
                                </>
                              )
                            )}
                          </div>
                        )}

                        {selectedInvoice?.breakdown?.booking_fee.length > 0 && (
                          <div className="mt-4">
                            <div className="pb-4">
                              <span className="text-lg font-semibold text-gray-700 dark:text-gray-300">
                                Booking Fee
                              </span>
                            </div>
                            {selectedInvoice?.breakdown?.booking_fee?.map(
                              (bookingFee: any) => (
                                <>
                                  <div className="flex justify-between ">
                                    <span>
                                      {bookingFee.description
                                        ? bookingFee.description
                                        : bookingFee.name}
                                    </span>
                                    <div className="flex flex-col items-end">
                                      <span className="text-xl font-medium text-gray-900 dark:text-gray-100">
                                        ${bookingFee.total}
                                      </span>
                                      <span>
                                        {bookingFee.rate.includes("%")
                                          ? bookingFee.rate
                                          : `$${bookingFee.rate}`}
                                      </span>
                                    </div>
                                  </div>
                                </>
                              )
                            )}
                          </div>
                        )}

                        {selectedInvoice?.breakdown?.taxes.length > 0 && (
                          <div className="mt-4">
                            <span className="text-lg font-semibold text-gray-700 dark:text-gray-300">
                              Tax & Fee
                            </span>
                            {selectedInvoice?.breakdown?.taxes?.map(
                              (taxes: any) => (
                                <>
                                  <div className="flex justify-between ">
                                    <span>
                                      {taxes.description
                                        ? taxes.description
                                        : taxes.name}
                                    </span>
                                    <div className="flex flex-col items-end">
                                      <span className="text-xl font-medium text-gray-900 dark:text-gray-100">
                                        ${taxes.total}
                                      </span>
                                      <span>
                                        {taxes.rate.includes("%")
                                          ? taxes.rate
                                          : `$${taxes.rate}`}
                                      </span>
                                    </div>
                                  </div>
                                </>
                              )
                            )}
                          </div>
                        )}

                        {selectedInvoice?.coupon_info?.id && (
                          <div className="mt-4">
                            <span className="text-lg font-semibold text-text-color">
                              Coupon
                            </span>

                            <>
                              <div className="flex justify-between ">
                                <span>
                                  {selectedInvoice?.coupon_info?.name}
                                </span>
                                <div className="flex flex-col items-end">
                                  <span className="text-xl font-medium text-text-color">
                                    ${selectedInvoice?.coupon_discount}
                                  </span>
                                  <span>
                                    {selectedInvoice?.coupon_info?.coupon_type.includes(
                                      "percentage"
                                    )
                                      ? selectedInvoice?.coupon_info?.amount +
                                        "%"
                                      : `$${selectedInvoice?.coupon_info?.amount}`}
                                  </span>
                                </div>
                              </div>
                            </>
                          </div>
                        )}

                        {(selectedInvoice?.breakdown?.discount &&
                          Object.keys(selectedInvoice?.breakdown?.discount)
                            .length > 0) ||
                        selectedInvoice?.discount !== "0.00" ? (
                          <>
                            {selectedInvoice?.breakdown?.discount &&
                            Object.keys(selectedInvoice?.breakdown?.discount)
                              .length > 0 ? (
                              <div className="mt-4">
                                <div className="flex justify-between ">
                                  <span className="text-lg font-semibold text-gray-700 dark:text-gray-300">
                                    Discount
                                  </span>

                                  <div className="flex flex-col items-end">
                                    <span className="text-xl font-medium text-gray-900 dark:text-gray-100">
                                      - $
                                      {
                                        selectedInvoice?.breakdown?.discount
                                          ?.total
                                      }
                                    </span>
                                    <span>
                                      {
                                        selectedInvoice?.breakdown?.discount
                                          ?.rate
                                      }
                                    </span>
                                  </div>
                                </div>
                              </div>
                            ) : (
                              selectedInvoice?.discount !== "0.00" && (
                                <div className="mt-4">
                                  <div className="flex justify-between ">
                                    <span className="text-lg font-normal text-gray-700 dark:text-gray-300">
                                      Discount
                                    </span>
                                    <span className="text-xl font-medium text-gray-900 dark:text-gray-100">
                                      ${selectedInvoice?.discount}
                                    </span>
                                  </div>
                                </div>
                              )
                            )}
                          </>
                        ) : null}

                        {selectedInvoice?.breakdown?.other?.length > 0 && (
                          <div className="mt-4">
                            <span className="text-lg font-semibold text-gray-700 dark:text-gray-300">
                              Others
                            </span>
                            {selectedInvoice?.breakdown?.other?.map(
                              (other: any) => (
                                <div
                                  key={other.name}
                                  className="flex justify-between"
                                >
                                  <span>{other.name}</span>
                                  <div className="flex flex-col items-end">
                                    <span className="text-xl font-medium text-gray-900 dark:text-gray-100">
                                      ${other.total}
                                    </span>
                                    <span>${other.rate}</span>
                                  </div>
                                </div>
                              )
                            )}
                          </div>
                        )}

                        <div className="mt-8 border-gray-200 dark:border-gray-700 pt-4">
                          <div className="flex justify-between ">
                            <div>
                              <span className="text-lg font-semibold text-gray-700 dark:text-gray-300">
                                Total Rental Price
                              </span>
                              <p className="mt-1 text-sm text-gray-500 dark:text-gray-400">
                                Overall price rental
                              </p>
                            </div>
                            <div>
                              <span className="text-xl font-medium text-gray-900 dark:text-gray-100">
                                $
                                {selectedInvoice?.total_price_after_coupon_without_security
                                  ? selectedInvoice?.total_price_after_coupon_without_security
                                  : selectedInvoice?.total_price_without_security}
                              </span>
                            </div>
                          </div>
                        </div>

                        {selectedInvoice?.security_deposit_total !== "0.00" && (
                          <div className="mt-4">
                            <div className="flex justify-between ">
                              <span className="text-lg font-semibold text-gray-700 dark:text-gray-300">
                                Total Deposit
                              </span>
                              <span className="text-xl font-medium text-gray-900 dark:text-gray-100">
                                ${selectedInvoice?.security_deposit_total}
                              </span>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  </span>
                </DialogPanel>
              </TransitionChild>
            </div>
          </div>
        </Dialog>
      </Transition>
      <Transition appear show={isTermOpen} as={Fragment}>
        <Dialog
          as="div"
          className="HeroSearchFormMobile__Dialog relative z-50"
          onClose={() => {
            setIsTermOpen(false);
          }}
          static={true}
        >
          <div className="fixed inset-0 bg-neutral-100 dark:bg-neutral-900">
            <div className="flex h-full">
              <Transition
                as={Fragment}
                enter="ease-out transition-transform"
                enterFrom="opacity-0 translate-y-52"
                enterTo="opacity-100 translate-y-0"
                leave="ease-in transition-transform"
                leaveFrom="opacity-100 translate-y-0"
                leaveTo="opacity-0 translate-y-52"
              >
                <DialogPanel className="relative h-full w-full overflow-hidden flex-1 flex flex-col justify-between ">
                  <>
                    <div className="absolute left-4 top-4">
                      <button
                        className="focus:outline-none focus:ring-0"
                        onClick={close}
                      >
                        <XMarkIcon
                          onClick={() => {
                            setIsTermOpen(false);
                          }}
                          className="w-5 h-5 text-black dark:text-white"
                        />
                      </button>
                    </div>

                    <div className="flex-1 pt-12 p-1 flex flex-col overflow-auto">
                      <div className="flex-1 flex flex-col bg-white dark:bg-neutral-800 z-10">
                        <div className="flex-1 flex flex-col transition-opacity animate-[myblur_0.4s_ease-in-out] overflow-auto">
                          <PrivacyPolicy terms={privacyPolicy} />
                        </div>
                      </div>
                    </div>
                  </>
                </DialogPanel>
              </Transition>
            </div>
          </div>
        </Dialog>
      </Transition>
      <Transition appear show={isCancellationOpen} as={Fragment}>
        <Dialog
          as="div"
          className="HeroSearchFormMobile__Dialog relative z-50"
          onClose={() => {
            setIsCancellationOpen(false);
          }}
          static={true}
        >
          <div className="fixed inset-0 bg-neutral-100 dark:bg-neutral-900">
            <div className="flex h-full">
              <Transition
                as={Fragment}
                enter="ease-out transition-transform"
                enterFrom="opacity-0 translate-y-52"
                enterTo="opacity-100 translate-y-0"
                leave="ease-in transition-transform"
                leaveFrom="opacity-100 translate-y-0"
                leaveTo="opacity-0 translate-y-52"
              >
                <DialogPanel className="relative h-full w-full overflow-hidden flex-1 flex flex-col justify-between ">
                  <>
                    <div className="absolute left-4 top-4 z-0">
                      <button
                        className="focus:outline-none focus:ring-0"
                        onClick={close}
                      >
                        <XMarkIcon
                          onClick={() => {
                            setIsCancellationOpen(false);
                          }}
                          className="w-5 h-5 text-black dark:text-white"
                        />
                      </button>
                    </div>

                    <div className="flex-1 pt-12 p-1 flex flex-col overflow-auto">
                      <div className="flex-1 flex flex-col bg-white dark:bg-neutral-800 z-10">
                        <div className="flex-1 flex flex-col transition-opacity animate-[myblur_0.4s_ease-in-out] overflow-auto">
                          <Cancellation terms={cancellationPolicy} />
                        </div>
                      </div>
                    </div>
                  </>
                </DialogPanel>
              </Transition>
            </div>
          </div>
        </Dialog>
      </Transition>
    </>
  );
}
